import React from "react";
import "./Divider.css";

const Divider = () => {
  return <hr className="divider" />;
};

export default Divider;
